import React from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@mui/material';
import { VerificationDocument } from '@/types/types';
import { usePhrase } from '@/hooks';
import { VERIFICATION_DOCUMENTS_PHRASES } from '@/consts/phrases/verificationPhrases';

export interface RemoveDocumentDialogProps {
    document: VerificationDocument | undefined;
    removeDocument: (id: number) => void;
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const RemoveDocumentDialog = (props: RemoveDocumentDialogProps) => {
    const { t } = usePhrase();
    const handleClose = (acceptsRemoveDocument: boolean) => {
        props.setOpen(false);
        if (acceptsRemoveDocument && props.document) {
            props.removeDocument(props.document.id);
        }
    };

    return (
        <Dialog onClose={handleClose} open={props.open} data-testid="remove-dialog">
            <DialogTitle>{t(VERIFICATION_DOCUMENTS_PHRASES.REMOVE_DIALOG_TITLE)}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {props.document?.filename &&
                        t(VERIFICATION_DOCUMENTS_PHRASES.REMOVE_DIALOG_BODY, {
                            replaceTextVars: [props.document.filename],
                        })}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    color="secondary"
                    variant="outlined"
                    onClick={() => handleClose(false)}
                    data-testid="dialog-cancel"
                >
                    {t(VERIFICATION_DOCUMENTS_PHRASES.CANCEL)}
                </Button>
                <Button
                    color="primary"
                    variant="contained"
                    onClick={() => handleClose(true)}
                    data-testid="dialog-accept"
                >
                    {t(VERIFICATION_DOCUMENTS_PHRASES.REMOVE)}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
